import styled from 'styled-components';
const cleanButton = `
  position: relative;
  border: 0px;
  padding: 0px;
  margin: 0px;
  background-color: #ffffff;
  font-size: 14px;
  width: 24px;
  line-height: 24px;
  border-radius: 50%;
  outline: 0;
  display: flex;
  align-items: center;
	justify-content: center;
	
	&:hover {
		border-radius: 50px;
		text-decoration: none;
	}
`;
const activePage = `
  content: '';
  display: block;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  position: absolute;
  z-index: 1;
  right: 0;
  bottom: 0;
  top: 0;
	left: 0;
`;
const disabledAnchor = `
	&:disabled,
	&[disabled] {
		pointer-events: none;
		cursor: default;
	}
`;
export const PaginationComponent = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 92px;
`;
export const PagesList = styled.div `
  margin: 0px;
  padding: 0px 4px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  height: 24px;

  button {
    font-family: ${({ theme }) => theme.fonts.families.primary};
  }
`;
export const PageLinkAnchor = styled.a `
  ${cleanButton}
  color: ${({ theme }) => theme.colors.grey48};
  &:hover {
		background: ${({ theme }) => theme.colors.grey8};
    color: ${({ theme }) => theme.colors.grey48};
  }
  ${({ isActive, theme }) => isActive &&
    `width: 28px;
			height: 28px;	
			position: relative;

			span {
			position: relative;
			z-index: 2;
			font-weight: 600;
			font-size: 16px;
			color: white;
			}

	&:after {
		${activePage}
    background-color: ${theme.colors.secondary.lighten};
	}`}
`;
export const Etc = styled.span `
  font-size: 14px;
  line-height: 24px;
  width: 24px;
  height: 24px;
  text-align: center;
`;
export const PrevPageAnchor = styled.a `
  ${cleanButton}
  color: ${({ theme }) => theme.colors.grey48};
  &:hover {
		background: ${({ theme }) => theme.colors.grey8};
    color: ${({ theme }) => theme.colors.grey48};
  }
  height: 24px;
  margin-right: 16px;
  border-radius: 50%;
  text-decoration: none;
  ${disabledAnchor}
  &:disabled,
	&[disabled] {
		background: ${({ theme }) => theme.colors.grey4};
    i:before {
			background-color: ${({ theme }) => theme.colors.grey24};
		}
  }
`;
export const NextPageAnchor = styled.a `
  ${cleanButton}
  color: ${({ theme }) => theme.colors.grey48};
  &:hover {
		background: ${({ theme }) => theme.colors.grey8};
    color: ${({ theme }) => theme.colors.grey48};
  }
  height: 24px;
  margin-left: 16px;
  border-radius: 50%;
  text-decoration: none;
  ${disabledAnchor}
  &:disabled,
	&[disabled] {
		background: ${({ theme }) => theme.colors.grey4};
    i:before {
			background-color: ${({ theme }) => theme.colors.grey24};
		}
  }
`;
